import { api, fetchWithAuth } from './api';

export interface BrandingSettings {
  app_name: string;
  logo_url: string | null;
  favicon_url: string | null;
  primary_color: string;
  accent_color: string;
}

export interface PublicBranding {
  app_name: string;
  logo_url: string | null;
}

export async function fetchPublicBranding(): Promise<PublicBranding> {
  const res = await fetch('/api/branding/public');
  if (!res.ok) return { app_name: 'Agency OS', logo_url: null };
  return res.json();
}

export const brandingApi = {
  fetchBranding: () => api.get<BrandingSettings>('/branding'),

  updateBranding: (
    data: Partial<Pick<BrandingSettings, 'app_name' | 'primary_color' | 'accent_color'>>
  ) => api.patch<BrandingSettings>('/branding', data),

  uploadLogo: async (file: File): Promise<{ logo_url: string; favicon_url: string }> => {
    const form = new FormData();
    form.append('file', file);
    const res = await fetchWithAuth('/api/branding/logo', { method: 'POST', body: form });
    return res.json();
  },
};
